import { render, staticRenderFns } from "./EmbedScreen.vue?vue&type=template&id=2f6ec46e"
import script from "./EmbedScreen.vue?vue&type=script&lang=js"
export * from "./EmbedScreen.vue?vue&type=script&lang=js"
import style0 from "./EmbedScreen.vue?vue&type=style&index=0&id=2f6ec46e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports